module.exports = __webpack_public_path__ + "02_mustache_brown.9bd45d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/02_mustache_brown.png
// module id = XOih
// module chunks = 0